module.exports = __webpack_public_path__ + "static/media/nima_walking_2b.9247b4ed.gif";